import { CartView } from '@/components/cart/cart-view';

export default function CartPage() {
  return (
    <div className="mx-auto max-w-[1180px] px-[30px] py-12">
      <h1 className="mb-8 text-[32px] font-extrabold tracking-[-0.03em] sm:text-[38px]">
        Your cart
      </h1>
      <CartView />
    </div>
  );
}
